import { useState } from 'react'
import { adminAgentsAPI } from '../../../services/api'

export function useAgentBuilder() {
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  const createAgent = async (formData) => {
    setSaving(true)
    setError(null)
    try {
      const agent = await adminAgentsAPI.createAgent(formData)
      return agent
    } catch (e) {
      const msg = e.response?.data?.detail || e.message || 'Failed to create agent'
      setError(msg)
      return null
    } finally {
      setSaving(false)
    }
  }

  const updateAgent = async (name, formData) => {
    setSaving(true)
    setError(null)
    try {
      const agent = await adminAgentsAPI.updateAgent(name, formData)
      return agent
    } catch (e) {
      const msg = e.response?.data?.detail || e.message || 'Failed to update agent'
      setError(msg)
      return null
    } finally {
      setSaving(false)
    }
  }

  const deleteAgent = async (name) => {
    setSaving(true)
    setError(null)
    try {
      await adminAgentsAPI.deleteAgent(name)
      return true
    } catch (e) {
      const msg = e.response?.data?.detail || e.message || 'Failed to delete agent'
      setError(msg)
      return false
    } finally {
      setSaving(false)
    }
  }

  return { createAgent, updateAgent, deleteAgent, saving, error, clearError: () => setError(null) }
}
